import { CardHeader, WithStyles, createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React from "react";

import Card from "../../../../components/Card";

const styles = createStyles({
  title: {
    color: "white"
  }
});

interface Props extends WithStyles<typeof styles> {
  amount: string;
}

const PendingPositiveReserveCard = ({
  classes,
  amount
}: Props): JSX.Element => (
  <Card color="#4dc527">
    <CardHeader
      classes={{
        title: classes.title,
        subheader: classes.title
      }}
      title="Pending Positive Reserve"
      subheader={amount}
    />
  </Card>
);

export default withStyles(styles)(PendingPositiveReserveCard);
